/**
 * Mercado Pago a veces redirige con URL rota:
 * ...external_reference=cs_si_..._17902842512702preapproval_id=789e75...
 * (sin & antes de preapproval_id)
 */
export function normalizeMercadoPagoReturnParams(searchParams) {
  let externalReference =
    searchParams.get('external_reference')
    || searchParams.get('externalReference')
    || '';
  let preapprovalId =
    searchParams.get('preapproval_id')
    || searchParams.get('preapprovalId')
    || searchParams.get('id')
    || '';

  if (externalReference.includes('preapproval_id=')) {
    const idx = externalReference.indexOf('preapproval_id=');
    const tail = externalReference.slice(idx + 'preapproval_id='.length);
    const idMatch = tail.match(/^([a-f0-9]+)/i);
    if (idMatch && !preapprovalId) preapprovalId = idMatch[1];
    externalReference = externalReference.slice(0, idx).replace(/&$/, '');
  }

  const glued = externalReference.match(/^(.+_\d{10,})(preapproval_id=([a-f0-9]+))$/i);
  if (glued) {
    externalReference = glued[1];
    if (!preapprovalId) preapprovalId = glued[3];
  }

  if (!preapprovalId && typeof window !== 'undefined') {
    const raw = window.location.search || '';
    const fromRaw = raw.match(/preapproval_id=([a-f0-9]+)/i);
    if (fromRaw) preapprovalId = fromRaw[1];
    if (!externalReference) {
      const extRaw = raw.match(/external_reference=(cs_si_[^&]+)/i);
      if (extRaw) {
        let ext = extRaw[1];
        const fix = ext.match(/^(.+?)(preapproval_id=[a-f0-9]+)$/i);
        if (fix) {
          ext = fix[1];
          if (!preapprovalId) {
            preapprovalId = fix[2].replace(/^preapproval_id=/i, '');
          }
        }
        externalReference = ext;
      }
    }
  }

  return {
    externalReference: externalReference || undefined,
    preapprovalId: preapprovalId || undefined,
  };
}
